import { Option } from '../../../../../interfaces/Option';
import { OptionDto } from '../../../../../interfaces/dtos/OptionDto';

export default function transformData(countriesDto: OptionDto[]): Option[] {
  const data: Option[] = [];

  countriesDto?.forEach((c) => {
    data.push({
      value: c.code,
      label: c.name,
    });
  });
  return data;
}
